import { Route } from '../../config/router'
import { DesignLanguage, useIsDesignLanguage } from '@afterpaytouch/core'
import { useIsRoute } from '../../state'

export const useHideDividerForInlineArcadeComponents = (): boolean => {
  // TOOD: streamline this hook
  const isNewPaymentMethodPage = useIsRoute(Route.NEW_PAYMENT_METHOD)
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  return isNewPaymentMethodPage && isArcadeDesignLanguage
}
